import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-down"><path d="M4.17939 14.2367C3.98952 14.0141 3.94643 13.7014 4.06901 13.4358C4.19158 13.1701 4.45744 13 4.75001 13H8.00001V2.75C8.00001 2.33579 8.3358 2 8.75001 2H15.25C15.6642 2 16 2.33579 16 2.75V13H19.25C19.5426 13 19.8084 13.1701 19.931 13.4358C20.0536 13.7014 20.0105 14.0141 19.8206 14.2367L12.5706 22.7367C12.4281 22.9038 12.2196 23 12 23C11.7804 23 11.5719 22.9038 11.4294 22.7367L4.17939 14.2367Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathDown;
